<template>
  <v-snackbar v-model="snackbar" :timeout="timeout" :color="color" :location="location">
    {{ notice }}

    <template v-slot:actions>
      <v-btn :color="buttonColor" variant="text" @click="closeNotice"> Close </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppStore, type AppMode } from '@/store/app';

const appStore = useAppStore();
const { notice, mode, snackbar } = storeToRefs(appStore);

const color = computed(() => {
  const modeMap: Record<AppMode, string> = {
    'success': 'success',
    'error': 'error',
    'info': 'info',
    'warning': 'warning',
    '': 'primary'
  };
  return modeMap[mode.value] || 'primary';
});

const buttonColor = computed(() => {
  return mode.value === 'error' ? 'white' : 'primary';
});

const timeout = computed(() => {
  // Error messages don't auto-close
  return mode.value === 'error' ? -1 : 5000;
});

const location = computed(() => 'top right' as const);

const closeNotice = () => {
  appStore.closeNotice();
};

// Auto-close non-error messages
watch([notice, mode], ([newNotice, newMode]) => {
  if (newNotice && newMode && newMode !== 'error') {
    // Non-error messages auto-close via Vuetify timeout
  }
}, { immediate: true });
</script>
